import "bootstrap/dist/css/bootstrap.min.css";
import "./src/css/icons.css";
import "./src/css/style.css";
import "./src/css/design-system.css";

import "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "jquery.easing";

import "./src/js/validate.js";
import "./src/js/main.js";

// Removed unused jQuery plugins (Owl Carousel, Isotope, Venobox, Waypoints,
// counterUp). These were leftovers from the original eNno Bootstrap template:
// none of their target DOM selectors (.testimonials-carousel,
// .portfolio-container, .venobox, [data-toggle="counter-up"]) appear in any
// React component. Carousels are handled by react-bootstrap's <Carousel>.

// Gatsby navigates client-side, so the Meta Pixel only sees the first page
// load. Fire PageView on later route changes once the deferred pixel exists.
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation && typeof window.fbq === "function") {
    window.fbq("track", "PageView")
  }
  // Same for HubSpot. Only once its script has replaced the _hsq stub array:
  // queued calls would add a duplicate of the page view it logs on load.
  if (prevLocation && window._hsq && !Array.isArray(window._hsq)) {
    window._hsq.push(["setPath", location.pathname + location.search])
    window._hsq.push(["trackPageView"])
  }
};

// Control scroll behavior - always scroll to top on page navigation
export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0)
  return [0, 0]
};
